import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Void = () => /*#__PURE__*/_jsx("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2559 2C6.73301 2 2.25586 6.47715 2.25586 12C2.25586 17.5229 6.73301 22 12.2559 22C17.7787 22 22.2559 17.5229 22.2559 12C22.2559 6.47715 17.7787 2 12.2559 2ZM12.2559 20C7.83758 20 4.25586 16.4183 4.25586 12C4.25586 10.0951 4.92167 8.34561 6.03328 6.9717C6.21006 7.28775 6.46216 7.62051 6.77578 7.93414L16.3217 17.4801C16.6353 17.7937 16.9681 18.0458 17.2842 18.2226C15.9102 19.3342 14.1608 20 12.2559 20ZM18.4784 17.0283C19.59 15.6544 20.2559 13.9049 20.2559 12C20.2559 7.58172 16.6741 4 12.2559 4C10.3509 4 8.60147 4.66581 7.22756 5.77742C7.54361 5.9542 7.87637 6.2063 8.19 6.51992L17.7359 16.0659C18.0496 16.3795 18.3017 16.7123 18.4784 17.0283Z"
  })
});